import { NgClass } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { ActionComponentDef } from '@df/ui/api/action.component.def';
import { NotificationInitiatorService } from '../display/notification/notification-initiator.service';
@Component({
    selector: 'action',
    templateUrl: 'action.html',
    standalone: true,
    imports: [NgClass]
})
export class ActionComponent extends ActionComponentDef {
    @Input()
    icon?: string;
    /**
     * If set it will trigger notification on error
     * given values is to be used as titlte
     */
    @Input()
    notification?: string;
    /**
     * Notifiactions service
     */
    private notificationInitiatorService = inject(NotificationInitiatorService);
    /**
     * Extension to support notifications
     */
    protected override onUpdate() {
        if (this.notification && this.isResultVisible && this._status?.error) {
            this.notificationInitiatorService.push({
                title: this.notification,
                message: this._status.error
            });
        }
        super.onUpdate();
    }
}
